import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

import Schema from 'images/upload/publisher_schema.png'

function UploadingGuidelines({ triggerGuidelines }) {
  return (
    <div className="col-12 col-md-7 col-lg-6 col-xl-5 guidelines">
      <div className="u-mb10 guidelines__trigger" onClick={() => triggerGuidelines(false)}>
        Uploading guidelines <Icon type={['far', 'chevron-right']} className="ml-5 height-12" />
      </div>
      <p className="u-mb0">
        You can upload your model as an archive (.zip or .rar preferred) or as separate files
        (.obj, .fbx, .stl, etc.). Add previews in .png or .jpeg file formats.
        <br />
        Simply drag & drop your model folder on this page to upload.
      </p>

      <div className="guidelines__image">
        <img src={Schema} alt="guidelines schema" />
      </div>

      <div className="section-heading--small">Requirements and recommendations</div>
      <ul className="guidelines__list">
        <li>add wireframe previews</li>
        <li>all textures must be archived – otherwise they will show up as preview images</li>
        <li>archive large files for a smoother upload experience</li>
        <li>archive your model in a flat file structure</li>
        <li>single file size limit: 5.5 GB</li>
        <li>use the Latin alphabet for file names</li>
      </ul>
    </div>
  )
}

UploadingGuidelines.propTypes = {
  triggerGuidelines: PropTypes.func.isRequired,
}

export default UploadingGuidelines
